import { HomeOutlined } from "@ant-design/icons-vue";
import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import type { RouteRecordRaw } from 'vue-router'

export const dashboard_routes: RouteRecordRaw[] = [{
  path: '/dashboard',
  name: 'dashboard',
  component: () => getComponent(`pages/dashboard.vue`),
  meta: {
    title: () => 'Dashboard',
    layout: Layout,
    is_public: false,
    menu: {
      key: 'dashboard',
      label: 'Dashboard',
      icon: () => h(HomeOutlined),
      path: `${prefix}/dashboard`,
    },
  },

}]
